import RenderManager from "../rendering/render-manager";
import * as Events from "../utils/events";
import EntranceExit from "./EntranceExit";
import Base2DElementDynamic from "./base-2d-element-dynamic";
import getTabIndex from "../utils/tab-index";

class CooboLink extends Base2DElementDynamic {

    get type2d() { return "CooboLink"; }

    _createContainer() {
        const container = super._createContainer();

        container.classList.add("q3-coobolink");

        if (!Q3.editMode) {
            container.tabIndex = getTabIndex();
        }

        return container;
    }

    _initDefaultVars() {
        super._initDefaultVars();

        this._wh = new THREE.Vector2(150, 60).divide(RenderManager.getSize());
        this._cooboId = null;
        this._slideUuid = null;
        this._title = null;
        this._thumb = null;
        this._subTitle = 'Jump to this Coobo';
    }

    get supportsActions() { return true; }

    get title() { return this._title; }
    set title(val) { this._title = val; }

    get subTitle() { return this._subTitle; }
    set subTitle(val) { this._subTitle = val; }

    get cooboId() { return this._cooboId; }
    set cooboId(val) { this._cooboId = val; }

    get slideUuid() { return this._slideUuid; }
    set slideUuid(val) { this._slideUuid = val; }

    get thumb() { return this._thumb; }
    set thumb(val) { this._thumb = val; }

    get href() {
        return `${window.location.origin}${window.COOBO ? "/api" : ""}/view/${this.cooboId}${this.slideUuid ? "?slide=" + this.slideUuid : ""}`
    }

    _initValues(options) {
        this.parentLayer.domElement.style.overflow = "visible";

        this._cooboId = "cooboId" in options ? options.cooboId : this._cooboId;
        this._slideUuid = "slideUuid" in options ? options.slideUuid : this._slideUuid;
        this._title = "title" in options ? options.title : this._title;
        this._subTitle = "subTitle" in options ? options.subTitle : this._subTitle;
        this._thumb = "thumb" in options ? options.thumb : this._thumb;

        this._sizeSm = options.sizeSm ? options.sizeSm : {
            x: 0.05,
            y: 0.05,
        };

        this._sizeLg = options.sizeLg ? options.sizeLg : {
            x: 0.15,
            y: 0.15,
        };

    }

    constructor(options, parentLayer, uuid) {

        super(options, parentLayer, uuid);
        this.link = document.createElement("a");
        this.link.className = "link";
        // if (!Q3.editMode) {
        //     this.link.href = this.href;

        //     const listener = event => {
        //         event.preventDefault();
        //         Q3.loadTour(this.cooboId, this.slideUuid);
        //         this.link.removeEventListener("click", listener);
        //     }

        //     this.link.addEventListener("click", listener);
        // }
        this.link = this.getLinkContent();
        this.domElement.appendChild(this.link);
        if (Q3.isReady) {
            this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
            this.enterExitCtrl.init(options);
        } else {
            Q3.Events.listen("tourReady", () => {
                this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
                this.enterExitCtrl.init(options);
            });
        }

        if (Q3.editMode) {
            this.domElement.addEventListener('click', e => {
                this.selectHandler(e);
            }, false);
        } else {
            const listener = event => {
                event.preventDefault();
                Q3.loadTour(this.cooboId, this.slideUuid);
                this.domElement.removeEventListener("click", listener);
            };

            this.domElement.addEventListener("click", listener);
        }

        this.redraw = this.redraw.bind(this);
        this.replaceLink = this.replaceLink.bind(this);

        this.handleListeners(true);

        this.redraw();

    }

    handleListeners(add) {
        Events[add ? "listen" : "unlisten"]("viewportchanged", this.redraw);
        Events[add ? "listen" : "unlisten"]("splashremoved", this.redraw);
    }

    replaceLink(data) {
        this.cooboId = this.data.cooboId = data.id;
        this.title = this.data.title = data.title;
        this.subTitle = this.data.subTitle = data.subTitle;
        this.thumb = this.data.thumb = data.thumb;
        this.slideUuid = this.data.slideUuid = data.slideUuid;
        let oldLink = this.link;
        this.link = this.getLinkContent();
        this.domElement.replaceChild(this.link, oldLink);
    }

    checkForUpdate() {
        $.ajax({
            url: (window.COOBO ? "/api" : "") + "/coobo-link/" + this.cooboId,
            // url: "https://preprodms.embibe.com/coobo_ms/demo/" + this.cooboId,
            type: 'GET',
            success: (res) => {
                if (!res.error) {
                    if (this.slideUuid) {
                        res.slideUuid = this.slideUuid;
                    }
                    this.replaceLink(res);
                }
            },
            error: (err) => {
                this.setState({ error: err.message || "Unknown Error", isLoading: false })
            }
        });

    }

    playLeavingAnimation() {
        this.enterExitCtrl.playLeave();
    }

    cancelLeavingAnimation() {
        this.enterExitCtrl.cancelLeave();
    }

    hide() {

        this.domElement.classList.add('2d-element-hidden');

    }

    show() {
        this.domElement.classList.remove('2d-element-hidden');
    }

    getLinkContent() {
        let link = document.createElement("a");
        link.className = "link";
        let thumb_div = document.createElement("div");
        thumb_div.className = 'thumb';
        let img = document.createElement("img");
        img.src = this.thumb;
        thumb_div.appendChild(img);
        let txt_div = document.createElement("div");
        txt_div.className = 'txt';
        let jump_div = document.createElement("div");
        jump_div.className = 'jump';
        jump_div.innerText = this.subTitle;
        let tour_name_el = document.createElement("div");
        tour_name_el.className = 'tour-name';
        tour_name_el.innerHTML = this.title;
        txt_div.appendChild(jump_div);
        txt_div.appendChild(tour_name_el);
        link.appendChild(thumb_div);
        link.appendChild(txt_div);
        return link;
    }

    getBBox() {
        const bbox = this.domElement.getBoundingClientRect();

        let x, y;

        if (!Q3.editMode) {
            x = this.position * 100;
            y = this.position * 100;
        }

        return { x, y, w: bbox.width + x, h: bbox.height + y };
    }

    redraw(width, height) {

        if (!width) width = RenderManager.domElement.width / RenderManager.pixelRatio;
        if (!height) height = (RenderManager.domElement.height) / RenderManager.pixelRatio;

        if (!Q3.editMode) {
            width = Q3.letterbox.offsetWidth / RenderManager.pixelRatio;
            height = (Q3.letterbox.offsetHeight) / RenderManager.pixelRatio;
        }

        let currentSize = this.getVWSize();
        if (this[currentSize]) {
            if (this.resizeable) {
                Object.assign(this, this[currentSize]);
            } else {
                Object.assign(this, { x: this[currentSize].x, y: this[currentSize].y, fontSize: this[currentSize].fontSize });
            }
        }


        if (Q3.editMode) {
            if (Q3.mobileView && this.hiddenMobile) this.domElement.style.opacity = 0.4;
            else if (!Q3.mobileView && this.hiddenDesktop) this.domElement.style.opacity = 0.4;
            else this.domElement.style.opacity = 1;
        }

        let [x, y] = this._calcPosition(width, height);

        this.domElement.style.position = "absolute";
        this.domElement.style.top = Math.round(y) + "px";
        this.domElement.style.left = Math.round(x) + "px";

        if (Q3.editMode)
            this.domElement.classList[(Q3.selected === this && !Q3.multiSelect[this.uuid]) ? "add" : "remove"]("is-selected")

        if (this.objChanged) {
            Events.fire("objchanged");
            this.objChanged = false;
        }
    }

    delete() {

        this.handleListeners(false);

        this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 1);

        delete this.domElement;

        if (Q3.selected === this) {
            Q3.selected = null;
            Events.fire('selectchange');
        }

    }

    clone() {

        const button = new Button({
            content: this.content,
            x: this.x + 0.01,
            y: this.y + 0.01,
        },
            this.parentLayer,
            THREE.Math.generateUUID()
        );

        Q3.data.layers.layers2D[button.parentLayer.uuid].objects[button.uuid] = {
            type: 'text',
            content: button.content,
            x: button.x,
            y: button.y,
        };

        this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 0, button);

        return button;

    }
    setData(data) {
        if (!this.resizeable) {
            delete data.width;
            delete data.height;
        }
        let currentSize = this.getVWSize();

        Object.assign(this[currentSize], data);

        const object = this.data;

        if (!object[currentSize]) { object[currentSize] = {}; }

        Object.assign(object[currentSize], data);

        this.redraw();
    }

    get width() {
        return this.resizeable ? this._wh.x : this.domElement.offsetWidth / Q3.container.offsetWidth;
    }

    set width(val) {
        this._wh.x = val;
    }

    get height() {
        return this.resizeable ? this._wh.y : this.domElement.offsetHeight / Q3.container.offsetHeight;
    }

    set height(val) {
        this._wh.y = val;
    }
}

export default CooboLink;
export { CooboLink };
